import React, { FC } from "react";
import { List } from "@mui/material";
import { IGroupedDevices } from "common/store/DeviceStore";
import BladeItem from "./BladeItem";

interface IProps {
  groupedDevices: IGroupedDevices[];
  bgColor: string;
  plusMinusIconLevel: number;
  level: number;
}

const Blade: FC<IProps> = (props) => {
  const { level, plusMinusIconLevel, groupedDevices, bgColor } = props;

  return (
    <List
      disablePadding
      sx={{ width: "100%", maxWidth: 300, bgcolor: bgColor }}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      <BladeItem level={level} plusMinusIconLevel={plusMinusIconLevel} blades={groupedDevices} />
    </List>
  );
};

export default Blade;
